import React from 'react';
import PropTypes from 'prop-types';
import * as steps from '../../../state-management/constants/assessmentSteps';
import AssessmentSectionQuestionsContainer from '../../AssessmentSectionQuestions/AssessmentSectionQuestions';

const StepSwitch = (props) => {
    const {
        currentStep: {
            id, name, page,
        },
        token,
    } = props;

    switch (name) {
        case steps.STEP_SECTION_QUESTIONS:
            return (
                <AssessmentSectionQuestionsContainer
                    page={page}
                    sectionId={id}
                    token={token}
                />
            );
        default:
            return (
                <AssessmentSectionQuestionsContainer
                    page={page}
                    sectionId={id}
                    token={token}
                />
            );
    }
};

StepSwitch.propTypes = {
    currentStep: PropTypes.shape({}),
    nextStep: PropTypes.shape({}),
    token: PropTypes.string,
    assessmentLanguage: PropTypes.string.isRequired,
};

StepSwitch.defaultProps = {
    currentStep: {
        name: '',
    },
    nextStep: {
        name: '',
    },
    token: '',
};

export default StepSwitch;
